<template>
    <b-modal :active.sync="show" id="createContractModal" aria-modal :width="600" :can-cancel="false">
        <div class="modal-card" style="width: auto">
            <header class="modal-card-head" v-show="status == ''"><p class="modal-card-title">Contract aanmaken</p></header>
            <section class="modal-card-body" style="overflow: hidden;">

                <div v-if="status == ''">
                    <b-notification type="is-info" :closable="false" v-if="requireContractSigning">
                        <strong>Contractondertekening vereist:</strong> De onderstaande opties zijn verplicht ingeschakeld, omdat de klant het contract eerst moet ondertekenen voordat het geactiveerd en verzonden kan worden.
                    </b-notification>

                    <p><strong>Algemeen</strong></p>

                    <div class="field">
                        <b-checkbox v-model="createSteps.require_signing">
                            Contractondertekening vereist
                            <ContractSigningInfoModal />
                        </b-checkbox>
                    </div>

                    <div class="field" v-if="user.role == 'pit' || user.organisation_connect">
                        <b-checkbox v-model="createSteps.connect">Toegang aanmaken na maken van contract.</b-checkbox>
                    </div>

                    <p><strong>PDF bestanden</strong></p>
                    <div class="field">
                        <b-checkbox v-model="createSteps.create_agreement" :disabled="requireContractSigning || createSteps.require_signing">Genereer het huurovereenkomst PDF-bestand.</b-checkbox>
                    </div>
                    <div class="field">
                        <b-checkbox v-model="createSteps.create_general" :disabled="requireContractSigning || createSteps.require_signing">Genereer het algemene bepaling PDF-bestand.</b-checkbox>
                    </div>

                    <p><strong>E-mail</strong></p>
                    <div class="field">
                        <b-checkbox v-model="createSteps.send_mail" :disabled="requireContractSigning || createSteps.require_signing">Verstuur een e-mail ter bevestiging naar {{ customerEmail }}.</b-checkbox>
                    </div>
                    <div class="field">
                        <b-checkbox v-model="createSteps.mail_attachments" :disabled="requireContractSigning || createSteps.require_signing || !createSteps.send_mail || (!createSteps.create_agreement && !createSteps.create_general) || user.role != 'pit'">Verstuur de gegenereerde PDF-bestanden mee per mail.</b-checkbox>
                    </div>
                </div>

                <div v-else>
                    <div class="process-image">
                        <img src="/images/undraw_agreement_aajr.svg" alt="process image" v-show="status == 'creating_contract'">
                        <img src="/images/undraw_printing_invoices_5r4r.svg" alt="process image" v-show="status == 'creating_invoices'">
                        <img src="/images/undraw_subscribe_vspl.svg" alt="process image" v-show="status == 'finalizing'">
                        <img src="/images/undraw_project_completed_w0oq.svg" alt="process image" v-show="status == 'created'">
                    </div>

                    <h3 class="text-center">
                        <span v-if="status == 'creating_contract'">Contract aanmaken..</span>
                        <span v-if="status == 'creating_invoices'">Facturen klaarzetten..</span>
                        <span v-if="status == 'finalizing'"><span v-show="createSteps.create_agreement || createSteps.create_general">Contract genereren</span><span v-show="createSteps.send_mail">&nbsp;en mail klaarzetten</span>..</span>
                        <span v-if="status == 'created'">Gereed!</span>
                    </h3>

                    <b-progress :value="stepsPercentage"></b-progress>
                </div>
            </section>
            <footer class="modal-card-foot text-right" v-show="status == ''">
                <button class="button" type="button" @click="$emit('cancelCreatingContract')">Annuleren</button>
                <button class="button is-success" @click="$emit('create', createSteps)">Aanmaken</button>
            </footer>
        </div>
    </b-modal>
</template>

<script>
import ContractSigningInfoModal from '../components/ContractSigningInfoModal.vue'

export default {
    name: 'ContractsRecordCreateModal',

    components: {
        ContractSigningInfoModal
    },

    props: {
        show: {
            type: Boolean,
            required: true,
            default: false
        },
        status: {
            type: String,
            required: true,
            default: ''
        },
        customerEmail: {
            type: String,
            required: false
        }
    },

    data() {
        return {
            createSteps: {
                create_agreement: true,
                create_general: true,
                send_mail: true,
                mail_attachments: true,
                connect: false,
                require_signing: false
            }
        }
    },

    computed: {
        stepsPercentage() {
            switch(this.status) {
                case 'creating_contract':
                    return 0
                break;
                case 'creating_invoices':
                    return 33
                break;
                case 'finalizing':
                    return 66
                break;
                case 'created':
                    return 100
                break;
                default:
                    return 0
                break;
            }
        },

        user() {
            return this.$store.state.user
        },

        requireContractSigning() {
            return this.user.organisation_settings &&
                   this.user.organisation_settings.require_contract_signing === 1
        }
    },

    created() {
        if (this.user.role == 'pit' || this.user.organisation_connect) {
            this.createSteps.connect = true
        }

        // Force required options when contract signing is required
        if (this.requireContractSigning) {
            this.createSteps.create_agreement = true
            this.createSteps.create_general = true
            this.createSteps.send_mail = true
            this.createSteps.mail_attachments = true
            this.createSteps.require_signing = true
        }
    },

    watch: {
        'createSteps.require_signing': function(newVal) {
            if (newVal) {
                // When require_signing is enabled, force all required options
                this.createSteps.create_agreement = true
                this.createSteps.create_general = true
                this.createSteps.send_mail = true
                this.createSteps.mail_attachments = true
            }
        },

        'createSteps.create_agreement': function(newVal) {
            if(!newVal && !this.createSteps.create_general){
                this.createSteps.mail_attachments = false
            }
        },

        'createSteps.create_general': function(newVal) {
            if(!newVal && !this.createSteps.create_agreement){
                this.createSteps.mail_attachments = false
            }
        },

        'createSteps.send_mail': function(newVal) {
            if(!newVal){
                this.createSteps.mail_attachments = false
            }
        }
    }
}
</script>
